import { IEnumeration } from 'utility-js-enumeration';

declare var Enumeration: IEnumeration;

const pathTaskSecondaryTextEnum = Enumeration('pathTaskSecondaryTextEnum', {
  // eslint-disable-line new-cap
  overdue: {
    secondaryText: 'Overdue on '
  },
  completed: {
    secondaryText: 'Completed on '
  },
  dismissed: {
    secondaryText: 'Hidden on '
  },
  active: {
    secondaryText: 'Due '
  },
  date_marker: {
    secondaryText: ''
  },
  auto_complete_pending: {
    secondaryText: 'PENDING VERIFICATION ON '
  },
  auto_complete_active: {
    secondaryText: ''
  },
  auto_completed: {
    secondaryText: 'VERIFIED ON '
  }
});

angular.module('data-ng-todos').constant('pathTaskSecondaryTextEnum', pathTaskSecondaryTextEnum);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/data/types/path_task_secondary_text.ts